export function toggleableFeatureAdapter(backendFeature) {
    var _a, _b, _c, _d, _e, _f;
    if (backendFeature) {
        return {
            canEnable: (_c = (_b = (_a = backendFeature.canOptIn) !== null && _a !== void 0 ? _a : backendFeature.canToggle) !== null && _b !== void 0 ? _b : backendFeature.canToggleForAll) !== null && _c !== void 0 ? _c : false,
            isEnabled: (_f = (_e = (_d = backendFeature.enabled) !== null && _d !== void 0 ? _d : backendFeature.isEnabled) !== null && _e !== void 0 ? _e : backendFeature.enabledForAll) !== null && _f !== void 0 ? _f : false,
        };
    }
    return {
        canEnable: false,
        isEnabled: false,
    };
}
